import React, { useState, useEffect } from 'react';
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  flexRender,
  getSortedRowModel,
} from '@tanstack/react-table';
// import { rankItem, compareItems } from '@tanstack/match-sorter-utils';
import { CSVLink } from 'react-csv';
import { Tooltip } from '@material-tailwind/react';

export const setCellLink = (value) => {
  if (value.notes) {
    return (
      <Tooltip content={value.notes} className="max-w-96">
        <a
          className="text-blue-500 underline"
          href={`AdminAccount/${value.id}`}
        >
          View
        </a>
      </Tooltip>
    );
  }
  return (
    <a className="text-blue-500 underline" href={`AdminAccount/${value.id}`}>
      View
    </a>
  );
};

export const setCellYear = ({ value }) => {
  const showYearCurrent = value === 'users' ? '2022' : value;
  return <div>{showYearCurrent}</div>;
};

export const setCellTaxTogether = ({ value }) => {
  return <div>{value}</div>;
};

export const setPhoneFormat = ({ value }) => {
  const cleanedValue = value?.replace(/\D/g, '');
  const match = cleanedValue?.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const formattedNumber = `(${match[1]}) ${match[2]}-${match[3]}`;
    return formattedNumber;
  }
  return '';
};

export const setDateReceivedOrder = ({ value }) => {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const formattedDate = `${month.toString().padStart(2, '0')}/${day
    .toString()
    .padStart(2, '0')}/${year}`;
  return formattedDate;
};

const ListClientsTable = ({ usersData, columnsTable }) => {
  const dataTable = usersData;
  const [csvData, setCsvData] = useState([]);

  const [columnFilters, setColumnFilters] = React.useState([]);
  const [globalFilter, setGlobalFilter] = React.useState('');

  // const fuzzyFilter = (row, columnId, value, addMeta) => {
  //   // Rank the item
  //   const itemRank = rankItem(row.getValue(columnId), value);

  //   // Store the itemRank info
  //   addMeta({
  //     itemRank,
  //   });

  //   // Return if the item should be filtered in/out
  //   return itemRank.passed;
  // };

  // const fuzzySort = (rowA, rowB, columnId) => {
  //   let dir = 0;

  //   // Only sort by rank if the column has ranking information
  //   if (rowA.columnFiltersMeta[columnId]) {
  //     dir = compareItems(
  //       rowA.columnFiltersMeta[columnId]?.itemRank,
  //       rowB.columnFiltersMeta[columnId]?.itemRank,
  //     );
  //   }

  //   // Provide an alphanumeric fallback for when the item ranks are equal
  //   return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
  // };

  const data = React.useMemo(() => dataTable, [dataTable]);
  const columns = React.useMemo(() => columnsTable, [columnsTable]);

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0, //custom initial page index
        pageSize: 100, //custom default page size
      },
    },
    state: {
      columnFilters,
      globalFilter,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    globalFilterFn: 'includesString',
  });

  const countTaxTogether = (data) => {
    return data.filter(
      (item) =>
        item.taxTogether === 'Yes' &&
        (item.maritalStatus === 'Married' ||
          item.maritalStatus === 'Common-Law'),
    ).length;
  };

  const convertToCSV = (objArray) => {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line !== '') line += ',';
        line += array[i][index];
      }
      str += line + '\r\n';
    }

    return str;
  };

  useEffect(() => {
    if (usersData.length === 0) return;
    const json = usersData.map((item) => {
      return {
        'First Name': item?.firstName,
        'Last Name': item?.lastName,
        email: item?.email,
        phone: item?.phone,
        'Date Received': item?.dateReceived,
        status: item?.status,
        'Admin Status': item?.AdminStatus,
        Notes: item?.AdminTextNoteClient?.replace(/,/g, '.').replace(
          /\n/g,
          ' | ',
        ),
        Couple:
          item?.taxTogether === 'Yes' &&
          (item?.maritalStatus === 'Married' ||
            item?.maritalStatus === 'Common-Law'),
        Payment: item?.payment,
        Province: item?.addressProv,
        PartnerEmail: item?.PartnerEmail,
        PartnerFirstName: item?.PartnerFirstName,
        PartnerLastName: item?.PartnerLastName,
      };
    });
    var header = Object.keys(json[0]);
    const csv =
      header.join(',') + '\r\n' + convertToCSV(json).replace(/undefined/g, '');
    setCsvData(csv);
  }, [usersData]);

  return (
    <>
      <div>
        <span className="text-blue-second font-bold">Filter:</span>
        <DebouncedInput
          value={globalFilter ?? ''}
          onChange={(value) => setGlobalFilter(String(value))}
          className="m-4 px-2 py-0.5 font-lg shadow border border-block"
          placeholder="Search all columns"
        />
      </div>
      <div className="flex flex-row text-md gap-4 mx-4 mb-2">
        <div>Total Users: {data.length - 1}</div>
        <div>Total Couple: {countTaxTogether(data)}</div>
        <div>|</div>
        <div>
          Total filtered: {table.getPrePaginationRowModel().rows.length}
        </div>
        <div className="ml-auto">
          <button className="bg-blue-gray-200 py-0.5 px-2 text-sm rounded-full">
            <CSVLink data={csvData}>Download CSV</CSVLink>
          </button>
        </div>
      </div>
      <table className="border-2 border-blue-primary border-separate border-spacing-0">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id} className="borderborder-black">
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    key={header.id}
                    className="border-l border-r border-b-2 border-black sticky top-0 bg-blue-100 z-50"
                  >
                    {header.isPlaceholder ? null : (
                      <>
                        <div
                          {...{
                            className: header.column.getCanSort()
                              ? 'cursor-pointer select-none'
                              : '',
                            onClick: header.column.getToggleSortingHandler(),
                          }}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                          {{
                            asc: ' 🔼',
                            desc: ' 🔽',
                          }[header.column.getIsSorted()] ?? null}
                        </div>
                        {[
                          'payment',
                          'status',
                          'AdminStatus',
                          'taxTogether',
                        ].includes(header.id) ? (
                          <div className="overflow-hidden text-sm">
                            <Filter column={header.column} table={table} />
                          </div>
                        ) : null}
                      </>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id} className="first:border-t-0">
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td
                      key={cell.id}
                      className="border border-blue-primary p-1"
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex items-center gap-2 justify-center my-2">
        <button
          className="border rounded p-1"
          onClick={() => table.setPageIndex(0)}
          disabled={!table.getCanPreviousPage()}
        >
          {'<<'}
        </button>
        <button
          className="border rounded p-1"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          {'<'}
        </button>
        <button
          className="border rounded p-1"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          {'>'}
        </button>
        <button
          className="border rounded p-1"
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}
        >
          {'>>'}
        </button>
        <span className="flex items-center gap-1">
          <div>Page</div>
          <strong>
            {table.getState().pagination.pageIndex + 1} of{' '}
            {table.getPageCount()}
          </strong>
        </span>
        <span className="flex items-center gap-1">
          | Go to page:
          <input
            type="number"
            defaultValue={table.getState().pagination.pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              table.setPageIndex(page);
            }}
            className="border px-2 rounded w-12"
          />
        </span>
        <select
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
        >
          {[10, 25, 100, 200, 500, 1000].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

function Filter({ column, table }) {
  const firstValue = table
    .getPreFilteredRowModel()
    .flatRows[0]?.getValue(column.id);

  const columnFilterValue = column.getFilterValue();

  const sortedUniqueValues = React.useMemo(
    () =>
      typeof firstValue === 'number'
        ? []
        : Array.from(column.getFacetedUniqueValues().keys()).sort(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [column.getFacetedUniqueValues()],
  );

  return typeof firstValue === 'number' ? (
    <div>
      <div className="flex space-x-2">
        <DebouncedInput
          type="number"
          min={Number(column.getFacetedMinMaxValues()?.[0] ?? '')}
          max={Number(column.getFacetedMinMaxValues()?.[1] ?? '')}
          value={columnFilterValue?.[0] ?? ''}
          onChange={(value) =>
            column.setFilterValue((old) => [value, old?.[1]])
          }
          placeholder={`Min ${
            column.getFacetedMinMaxValues()?.[0]
              ? `(${column.getFacetedMinMaxValues()?.[0]})`
              : ''
          }`}
          className="w-24 border shadow rounded"
        />
        <DebouncedInput
          type="number"
          min={Number(column.getFacetedMinMaxValues()?.[0] ?? '')}
          max={Number(column.getFacetedMinMaxValues()?.[1] ?? '')}
          value={columnFilterValue?.[1] ?? ''}
          onChange={(value) =>
            column.setFilterValue((old) => [old?.[0], value])
          }
          placeholder={`Max ${
            column.getFacetedMinMaxValues()?.[1]
              ? `(${column.getFacetedMinMaxValues()?.[1]})`
              : ''
          }`}
          className="w-24 border shadow rounded"
        />
      </div>
      <div className="h-1" />
    </div>
  ) : (
    <>
      <datalist id={column.id + 'list'}>
        {sortedUniqueValues.slice(0, 5000).map((value, i) => (
          <option value={value} key={value + i} />
        ))}
      </datalist>
      <DebouncedInput
        type="text"
        value={columnFilterValue ?? ''}
        onChange={(value) => column.setFilterValue(value)}
        placeholder={`Search (${column.getFacetedUniqueValues().size})`}
        className="w-28 border border-gray-700 shadow rounded px-0.5 mx-0.5"
        list={column.id + 'list'}
      />
      <div className="h-1" />
    </>
  );
}

function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 200,
  ...props
}) {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default ListClientsTable;
